import { render, staticRenderFns } from "./teacherMatingDetail.vue?vue&type=template&id=fe9f5e4c&scoped=true&"
import script from "./teacherMatingDetail.vue?vue&type=script&lang=js&"
export * from "./teacherMatingDetail.vue?vue&type=script&lang=js&"
import style0 from "./teacherMatingDetail.vue?vue&type=style&index=0&id=fe9f5e4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9f5e4c",
  null
  
)

export default component.exports